<!--
-------------------------------------------------------------------------------
-- Componente datModal - version Shop
-------------------------------------------------------------------------------
-- Historico:
--   -27/04/2020 - Iván Ferrando - Creación del componente
--
-- Descripción:
--    -Componente contenedor modal
--
-- Props:
--    -pTitle: agrega el titulo a la modal
--    -pType: determina de que tipo es la modal
--          -1- Si no se pone nada cogera el estilo general centrada al medio
--          -2- si colocamos el valor modalRight esto aplicara la clase con el mismo nombre y la modal se pegara a la derecha
--    -pWidth: ajusta el tamaño de la modal
--          -1- Se puede usar cualquier valor numerico
--          -2- Se puede aplicar la propiedad 'max-content' la cual ajusta el tamaño de la modal al contenido de la misma
--    -pAction: con esto determinamos los valores de los botones, el estilo, el tamaño y el tipo (con o sin icono)
--
-- Slots:
--     Marcan donde sera reemplazada la informacion interna de la modal
-------------------------------------------------------------------------------
-->

<template>
  <v-dialog v-model="value" persistent scrollable :content-class="pType" :width="pWidth">
    <v-card :height="pHeight" :style="cUserStyle" :class="{'modalsResize' : pFormSize > 550 , 'modalsResize-var' : pFormSize < 549, '': !pFormSize}">
      <v-card-title class="px-6 datModalTitleContainer" >
        <v-flex xs10 class="pa-0 datModalTitle">{{ pTitle }}</v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" class="mx-0" :class="pCloseIconStyle" :ripple="false">
          <v-icon color="datClose">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0 px-1 overflowX" :class="{'py-0' : pAction.length === 0}">
        <!-- se inyecta aquí el contenido -->
        <slot></slot>
        <!-- se inyecta aquí el contenido -->
      </v-card-text>
      <v-card-actions v-if="pAction.length > 0" class="justify-end">
        <v-flex text-xs-center v-for="item in pAction" :key="item.id" class="ma-2" :class="item.class ? item.class : 'shrink'">
          <v-btn :class="item.btnclass" flat @click="eventClick(item)">
            {{ item.name }}
            <v-icon v-if="item.icon" :class="item.name ? 'px-2': ''">
              {{ item.icon }}
            </v-icon>
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {

  props: {
    pTitle: {
      type: String,
      required: false
    },
    pType: {
      type: String,
      required: false
    },
    value: {
      type: Boolean,
      required: false,
      default: true
    },
    pWidth: {
      type: [String, Number],
      required: false,
      default: 880
    },
    pHeight: {
      type: [String, Number],
      required: false
    },
    pAction: {
      type: Array,
      required: false,
      default: () => []
    },
    pStepper: {
      type: Array,
      required: false,
      default: () => []
    },
    pFormSize: {
      type: [String, Number],
      required: false
    },
    pCloseIconStyle: {
      type: String,
      required: false,
      default: 'noHover'
    }
  },
  data () {
    return {
      height: 0
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
      this.$emit('reboot')
    },
    fNextStep () {
      this.$emit('fNextStep')
    },
    fBackStep () {
      this.$emit('fBackStep')
    },
    eventClick (item) {
      if (item.exec) {
        item.exec(item.value)
      }
    }
  },
  computed: {
    cUserStyle () {
      return {
        '--var-height': this.pFormSize + 'px'
      }
    }
  }
}
</script>